<template>
  <section class="my-attention">
    <ul v-if="myThemeData.length > 0">
      <li v-for="(item,index) in myThemeData" :key="index">
        <a class="avatar" :href="$i18n.path(`subject/${item.subjectId}`)" target="_blank">
          <img :src="item.coverImageUrl+'?x-oss-process=image/resize,m_fixed,w_240,h_240/quality,Q_60'" alt>
        </a>
        <div class="user-name">
          <a :href="$i18n.path(`subject/${item.subjectId}`)" target="_blank">
            <span class="user-nick">{{item.name}}</span>
          </a>
          <span class="user-pay"><span class="follow-number">{{item.followCount}}</span> 人关注</span>
        </div>
        <div style="flex-grow:1"></div>
        <BtnFocus class="attention" :subjectId="item.subjectId" :isFollow="item.isFollow" @success="moreMyTheme" />
      </li>
    </ul>
  </section>
</template>
<script>
import BtnFocus from "@/components/subject/btn-focus.vue";
import {
  mapMutations,
  mapGetters,
  mapState,
  mapActions
} from "vuex";
import * as types from "~/types";
export default {
  layout: "defalut",
  props: ["myThemeData"],
  components: {
    BtnFocus
  },
  data () {
    return {};
  },
  computed: {
    ...mapGetters("user", ["isLogin", "userId"])
  },
  mounted () { },
  methods: {
    moreMyTheme () {
      this.$emit("moreMyTheme");
    },
    ...mapMutations("user", [types.SHOW_LOGIN_FORM])
  },
  watch: {
    isLogin () {
      this.$emit("moreMyTheme");
    }
  }
};

</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.my-attention {
  width: 660px;
  padding: 20px 0 18px;
  background-color: #fff;
  position: relative;

  ul {
    width: 100%;
    // padding: 0 22px;

    li {
      border-bottom: 1px solid rgba(232, 232, 232, 0.8);
      padding: 20px 0;
      display: flex;
      align-items: center;
      align-content: center;

      &:last-child {
        border-bottom: none;
        margin: 0;
      }

      a {
        display: block;
      }

      .avatar {
        height: 60px;
        width: 60px;
        position: relative;
        z-index: 5;
        overflow: hidden;
        border-radius: 3px;

        img {
          height: 100%;
          width: 100%;
        }
      }

      .user-name {
        width: 480px;
        margin-left: 20px;

        .user-nick {
          font-weight: 600;
          line-height: 1.5em;
          font-size: 16px;
          color: rgba(34, 34, 34, 1);
        }

        .user-pay {
          font-size: 13px;
          color: rgba(131, 141, 151, 1);

          .follow-number {
            color: #222;
          }
        }
      }
    }
  }
}
</style>
